<template>
  <div>
    <a-modal v-model="visible" width="660px" :title="teamId ? '修改团队' : '添加团队'" ok-text="确认" cancel-text="取消" :ok-button-props="{ props: { loading: loading } }" @ok="submit" @cancel="close">
      <a-form-model ref="modalForm" :model="modalForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="Logo">
          <a-upload name="resource" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" :headers="headers" :action="actionUrl" @change="handleChange">
            <div v-if="modalForm.logo">
              <a-avatar shape="square" :size="128" :src="modalForm.logo" />
            </div>
            <div v-else>
              <a-icon :type="uplaadLoading ? 'loading' : 'plus'" />
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="团队名称" prop="name">
          <a-input v-model="modalForm.name" />
        </a-form-model-item>
        <a-form-model-item label="团队分类" prop="category">
          <a-select v-model="modalForm.category" show-search placeholder="团队分类">
            <a-select-option v-for="item in teamCategory" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="负责人" prop="owner">
          <user-select v-model="modalForm.owner" placeholder="负责人" show-search />
        </a-form-model-item>
        <a-form-model-item label="团队成员">
          <user-select v-model="modalForm.members" placeholder="团队成员" mode="multiple" show-search />
        </a-form-model-item>
        <a-form-model-item label="团队描述">
          <a-textarea v-model="modalForm.description" :auto-size="{ minRows: 3 }" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { getCookies } from '@/utils/utils';
import { teamCategory } from '@/utils/dictionary';
import { teamAdd, teamModify } from '@/api/system/team';

import UserSelect from '@/components/User/UserSelect';
export default {
  name: 'TeamModal',
  components: { UserSelect },
  props: {
    teamId: {
      type: [Number, String],
      default: null
    },
    teamData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      teamCategory,
      loading: false,
      uplaadLoading: false,
      visible: this.isShow,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      modalForm: {
        logo: null,
        category: 1,
        members: []
      },
      uploadData: {},
      actionUrl: `${process.env.VUE_APP_DADA_URL}/v1/basic/resourceUpload`,
      headers: {
        Authorization: getCookies()
      },
      rules: {
        category: [{ required: true, message: '团队分类不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '团队名称不能为空', trigger: 'blur' }],
        owner: [{ required: true, message: '团队负责人不能为空', trigger: 'blur' }]
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        if (this.teamId) {
          this.modalForm = {
            ...this.teamData,
            owner: this.teamData.owner.id,
            members: this.teamData.members.map(item => {
              return item.id;
            })
          };
        } else {
          this.modalForm = {};
        }
      }
    }
  },
  methods: {
    close() {
      this.loading = false;
      this.$emit('close');
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uplaadLoading = true;
        return;
      }
      if (info.file.status === 'done') {
        this.uplaadLoading = false;
        const { code, message, data } = info.file.response;
        if (code === 2000) {
          this.modalForm.logo = data.resource_url;
        } else {
          this.$message.warning(message);
        }
      }
    },

    submit() {
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.teamId) {
            teamModify({ team_id: this.teamId, ...this.modalForm })
              .then(() => {
                this.$message.success('团队修改成功');
                this.close();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            teamAdd(this.modalForm)
              .then(() => {
                this.$message.success('团队添加成功');
                this.close();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
